




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Product } from '@/models/catalog/Product';
import { UserRole } from '@/models/account/UserRole';
import { Permission, SEE_ORIGINAL_PRICE } from '@/models/account/Permission';
import { ProductOption } from '@/models/catalog/ProductOption';
import { ProductOptionValue } from '@/models/catalog/ProductOptionValue';
import { Price } from '@/models/catalog/Price';

import ColorDisplay from '@/components/App/Catalog/ColorDisplay.vue';

@Component({
    components: {
        'app-color-display': ColorDisplay,
    }
})
export default class ProductPriceTable extends Vue {
    @Prop()
    public product!: Product;

    public hiddenOptionTypes = [
        'INPUT_HEIGHT',
        'INPUT_WIDTH'
    ];

    get canSeeOriginalPrice (): boolean {
        return this.$store.getters['auth/hasPermission'](SEE_ORIGINAL_PRICE);
    }

    get hasStartCost (): boolean {
        return this.product.options.filter((option: ProductOption) => {
            return option.values.filter((value: ProductOptionValue) => {
                return value.start_cost !== null;
            }).length > 0;
        }).length > 0;
    }

    get visibleOptions (): ProductOption[] {
        return this.product.options.filter((option: ProductOption) => {
            if (this.hiddenOptionTypes.includes(option.type)) {
                return false;
            }

            if (option.type === 'COLOR') {
                let totalSum = 0;

                option.values.forEach((value: ProductOptionValue) => {
                    value.prices.forEach((price: Price) => {
                        totalSum += Math.round(price ? price.price : 0);
                    })
                })

                return totalSum > 0;
            }

            return true;
        });
    }

    public getCalculationMethodLabel(method: string): string {
        switch (method) {
            case 'PRICE_BY_SQUARE_METRE':
                return 'Pris per kvadratmeter';
            case 'PRICE_BY_WIDTH':
                return 'Pris per löpmeter (Överkant)';
            case 'PRICE_BY_WIDTH_X2':
                return 'Pris per löpmeter (Över & Underkant)';
            case 'PRICE_BY_HEIGHT':
                return 'Pris per löpmeter (Vänsterkant)';
            case 'PRICE_BY_HEIGHT_X2':
                return 'Pris per löpmeter (Vänster & Högerkant)';
            case 'PRICE_BY_CIRCUMFERENCE':
                return 'Pris per omkrets';
            case 'PRICE_BY_UNIT':
            default:
                return 'Styckpris';
        }
    }

    public getPriceUnitTitle(type: string) {
        switch (type) {
            case 'PRICE_PER_SQUARE_METER':
                return 'Kvadratmeter';
            case 'PRICE_PER_QUANTITY':
                return 'Antal';
        }
    }

    public getPriceUnit (type: string) {
        switch (type) {
            case 'PRICE_PER_SQUARE_METER':
                return 'm²';
            case 'PRICE_PER_QUANTITY':
                return 'st';
        }
    }

    public isColor (type: string) {
        return type === 'COLOR';
    }
}
